import { IChatbotState } from '../interfaces/ichatbot-status';

export const CHATBOT_STATE: IChatbotState = {
    active: false,
    azureAD: null,
    botAuth: null,
    chanelId: null
};
